export default "__VITE_ASSET__9adc5d9c__"